<!-- 分成方结算详情页 -->
<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div class="content">
      <ykc-detail-plus class="box-card" :labelWidth="140">
        <div slot="header" class="clearfix">
          <span>对账单信息</span>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="结算单号">
            <span>{{ dealData(formData.settleNo) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="结算时间">
            <span>{{ dealData(settleTimeText) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="站点编码">
            <span>{{ dealData(formData.stationCode) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="站点名称">
            <span>{{ dealData(formData.stationName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="结算方类型">
            <span>{{ dealData(formData.partnerTypeName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="结算方名称">
            <span>{{ dealData(formData.partnerName) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="结算金额">
            <span>{{ dealData(formData.settleTotalAmount) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="发票状态">
            <span>{{ dealData(formData.invoiceStatusName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="收款日期">
            <span>{{ dealData(formData.collectionDate) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="申请备注">
            <span>{{ dealData(formData.remark) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="审批状态">
            <span>{{ dealData(formData.statusName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="审批备注">
            <span>{{ dealData(formData.auditRemark) }}</span>
          </ykc-detail-item-plus>
        </div>
      </ykc-detail-plus>
    </div>
  </scroll-layout>
</template>

<script>
  import dayjs from 'dayjs';
  import { partnerSettleManage } from '@/service/apis';

  export default {
    name: 'PartnerSettleDetail',
    components: {},

    data() {
      return {
        id: '',
        formData: {},
        pageButtons: [
          {
            id: '0',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
      };
    },
    computed: {
      // 结算时间格式：2026-04-01 ~ 2026-05-31
      settleTimeText() {
        if (this.formData.startTime && this.formData.endTime) {
          const start = dayjs(this.formData.startTime).format('YYYY-MM-DD');
          const end = dayjs(this.formData.endTime).format('YYYY-MM-DD');
          return `${start} ~ ${end}`;
        }
        return '';
      },
    },
    created() {
      const { id } = this.$route.query;
      this.id = id;
      this.queryDetail();
    },
    methods: {
      dealData(value) {
        return value === null || value === undefined || value === '' ? '——' : value;
      },
      queryDetail() {
        if (this.id) {
          partnerSettleManage
            .getOne({ id: this.id })
            .then(res => {
              this.formData = res;
            })
            .catch(() => {});
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    .box-card {
      width: 100%;
      height: auto;
      margin: 10px 0px 0px 0px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      .flexBox {
        display: flex;
        margin-bottom: 20px;
      }
    }
  }
</style>
